<template>
  <section class="section">
    <div class="section__content section__column-container">
      <HeadingBlock :content="content" />
      <div class="section__column-group">
        <component
          :is="hasLink(link) ? 'a' : 'p'"
          :href="link.link"
          :target="hasLink(link) ? '_blank' : null"
          v-for="(link, linkKey) in content.blocks"
          :key="linkKey"
          class="section__column"
          v-reveal="{ delay: 25 * linkKey + 250 }"
        >
          <h3 class="small-title --arrow">
            <span>{{ link.title }}</span>
            <Icon id="arrow" v-if="hasLink(link)" />
          </h3>
          <p>{{ link.description }}</p>
        </component>
      </div>
    </div>
  </section>
</template>

<script>
import { HeadingBlock } from '@/components/blocks'
import { Icon } from '@/components/global'
import { hasLink } from '@/helpers'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'TwoColumnsSection',
  mixins: [DefaultSectionProps],
  components: { HeadingBlock, Icon },
  methods: { hasLink },
}
</script>
